import { Button, Card, Typography } from "@/components/ui";
import { CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

type RepairIntakeSuccessStateProps = {
  onStartNewForm: () => void;
  onReviewSubmission: () => void;
};

export function RepairIntakeSuccessState({ onStartNewForm, onReviewSubmission }: RepairIntakeSuccessStateProps) {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10 sm:px-6">
      <div className="mx-auto max-w-3xl">
        <Card className="border-gray-200 shadow-sm">
          <CardHeader className="space-y-3">
            <Typography variant="display-xs" weight="semibold">
              Repair Intake Form
            </Typography>
            <CardTitle>Submission saved</CardTitle>
            <CardDescription>
              The repair intake form has been saved to the local draft store. No API call was made.
            </CardDescription>
          </CardHeader>
          <CardContent className="flex flex-col gap-4 sm:flex-row">
            <Button onClick={onStartNewForm}>Start New Form</Button>
            <Button variant="outline" onClick={onReviewSubmission}>
              Review Submission
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
